// const DEFAULT_API_BASE = "http://127.0.0.1:8000/api";
//const DEFAULT_API_BASE = "http://172.20.7.9:8081/api";
//const DEFAULT_API_BASE = "https://devi360.injupemp.gob.hn:8443/api";
const DEFAULT_API_BASE = "https://bei360.injupemp.gob.hn:8444/api";
const API_BASE = (process.env.REACT_APP_BEI360_API || DEFAULT_API_BASE).replace(/\/$/, "");

export const getApiBase = () => API_BASE;
export const buildApiUrl = (path = "") => {
  const rawPath = String(path || "").trim();
  if (!rawPath) return API_BASE;
  if (/^https?:\/\//i.test(rawPath)) return rawPath;

  const normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;

  // Avoid duplicating "/api" when backend already returns absolute API paths.
  if (normalizedPath.startsWith("/api/") && /\/api$/i.test(API_BASE)) {
    const originBase = API_BASE.replace(/\/api$/i, "");
    return `${originBase}${normalizedPath}`;
  }

  return `${API_BASE}${normalizedPath}`;
};

const normalizeBearer = (token) => {
  if (!token) return "";
  const raw = String(token).trim();
  if (!raw || raw === "NA" || raw === "0") return "";
  return raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`;
};

const isoDate = (value) => {
  if (!value) return "";
  const str = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  const match = str.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  return "";
};

const fromDdMmYyyyToIso = (value) => {
  if (!value) return "";
  const str = String(value).trim();
  const m = str.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return isoDate(str);
};

const toBoolean = (value, fallback = false) => {
  if (typeof value === "boolean") return value;
  if (value === 1 || value === "1") return true;
  if (value === 0 || value === "0") return false;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (["si", "sí", "yes", "true", "t"].includes(v)) return true;
    if (["no", "false", "f"].includes(v)) return false;
  }
  return fallback;
};

const toText = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

const digitsOnly = (value) => toText(value).replace(/\D/g, "");

const formatLugarNacimientoReporte = (value) => {
  const raw = toText(value);
  if (!raw) return "";
  const primeraParte = toText(raw.split(",")[0]);
  return primeraParte || raw;
};

const yearsSinceDate = (value) => {
  const iso = isoDate(value);
  if (!iso) return "";
  const from = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(from.getTime())) return "";
  const now = new Date();
  let years = now.getFullYear() - from.getFullYear();
  const monthDiff = now.getMonth() - from.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < from.getDate())) {
    years -= 1;
  }
  return years >= 0 ? String(years) : "";
};

export const getAccessToken = (preferredToken = "") => {
  const preferred = normalizeBearer(preferredToken);
  if (preferred) return preferred;

  try {
    const raw = localStorage.getItem("authData");
    if (!raw) return "";
    const parsed = JSON.parse(raw);

    const tokenCandidates = [
      parsed?.token,
      parsed?.sessionData?.token,
      parsed?.access,
      parsed?.access_token,
      parsed?.jwt,
    ];

    for (const candidate of tokenCandidates) {
      const normalized = normalizeBearer(candidate);
      if (normalized) return normalized;
    }
    return "";
  } catch (_err) {
    return "";
  }
};

const getCurrentUserId = () => {
  const normalizeId = (value) => {
    if (value === undefined || value === null || value === "") return null;
    const raw = String(value).trim();
    if (!raw) return null;
    const num = Number(raw);
    if (Number.isInteger(num) && num > 0) return num;
    return null;
  };

  try {
    const raw = localStorage.getItem("authData");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const candidates = [
      parsed?.id,
      parsed?.user_id,
      parsed?.userId,
      parsed?.sessionData?.id,
      parsed?.sessionData?.user_id,
      parsed?.sessionData?.userId,
    ];
    for (const candidate of candidates) {
      const normalized = normalizeId(candidate);
      if (normalized !== null) return normalized;
    }
    return null;
  } catch (_err) {
    return null;
  }
};

const withUserIdRegistro = (payload = {}) => {
  const basePayload = payload && typeof payload === "object" ? payload : {};
  const existing = basePayload?.UserIdRegistro ?? basePayload?.userIdRegistro;
  if (existing !== undefined && existing !== null && String(existing).trim() !== "") {
    return basePayload;
  }
  const userId = getCurrentUserId();
  if (userId === null) return basePayload;
  return {
    ...basePayload,
    UserIdRegistro: userId,
  };
};

export const apiRequest = async (path, options = {}) => {
  const { authToken = "", ...fetchOptions } = options;
  const token = getAccessToken(authToken);
  const headers = {
    Accept: "application/json",
    ...(fetchOptions.headers || {}),
  };
  if (token) headers.Authorization = token;

  const response = await fetch(buildApiUrl(path), {
    ...fetchOptions,
    headers,
  });

  const data = await response.json().catch(() => ({}));

  if (response.status === 401 && data?.code === "token_not_valid") {
    window.dispatchEvent(new CustomEvent("session-expired"));
    const err = new Error("Sesión expirada");
    err.status = 401;
    err.payload = data;
    throw err;
  }

  if (!response.ok || data?.success === false) {
    const msg =
      data?.error ||
      data?.detail ||
      data?.message ||
      `Error HTTP ${response.status}`;
    const err = new Error(msg);
    err.status = response.status;
    err.payload = data;
    throw err;
  }
  return data;
};

export const getDesignacionFirma = async (authToken = "", options = {}) => {
  const puesto = String(options?.puesto || "DIRECTOR ESPECIALISTA PRESIDENTE").trim();
  const soloActivo = options?.soloActivo !== false;
  const params = new URLSearchParams();
  if (puesto) params.set("puesto", puesto);
  if (soloActivo) params.set("solo_activo", "1");
  const query = params.toString();
  const path = `/Enrolamiento/firmas/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken });
  return data?.firma || null;
};

const normalizeDesignacionEstado = (value) => {
  const raw = String(value || "").trim().toUpperCase();
  if (["A", "ACTIVO", "ACTIVA"].includes(raw)) return "ACTIVO";
  if (["P", "EN PROCESO", "EN_PROCESO", "PROCESO"].includes(raw)) return "EN PROCESO";
  if (["I", "INACTIVO", "INACTIVA"].includes(raw)) return "INACTIVO";
  return raw || "INACTIVO";
};

const normalizeBeneficiarioForUi = (item = {}) => ({
  id: item?.BeneficiarioId || item?.beneficiarioId || `${item?.DocumentoNumero || item?.dni || ""}-${item?.Nombre1 || item?.primerNombre || ""}-${item?.Apellido1 || item?.primerApellido || ""}`,
  beneficiarioId: item?.BeneficiarioId || item?.beneficiarioId || null,
  fkDesignacionId: item?.FKDesignacionId ?? item?.designacionId ?? null,
  dni: item?.DocumentoNumero || item?.dni || "",
  primerNombre: item?.Nombre1 || item?.primerNombre || "",
  segundoNombre: item?.Nombre2 || item?.segundoNombre || "",
  primerApellido: item?.Apellido1 || item?.primerApellido || "",
  segundoApellido: item?.Apellido2 || item?.segundoApellido || "",
  parentesco: item?.ParentescoDescripcion || (item?.FKParentescoId ?? item?.parentesco ?? ""),
  tipoDocumento: item?.FKDocumentoTipoId ?? item?.tipoDocumento ?? "",
  porcentaje: Number(item?.Porcentaje ?? item?.porcentaje ?? 0) || 0,
  fechaInicioBeneficio: item?.FechaInicioBeneficio || item?.fechaInicioBeneficio || "",
});

const groupBeneficiariosByDesignacion = (beneficiarios) => {
  const grouped = new Map();
  const withoutDesignacion = [];
  (beneficiarios || []).forEach((item) => {
    const normalized = normalizeBeneficiarioForUi(item);
    const key = normalized.fkDesignacionId;
    if (key === null || key === undefined || key === "") {
      withoutDesignacion.push(normalized);
      return;
    }
    const existing = grouped.get(String(key)) || [];
    existing.push(normalized);
    grouped.set(String(key), existing);
  });
  return { grouped, withoutDesignacion };
};

const toTimeValue = (value) => {
  const raw = toText(value);
  if (!raw) return Number.MIN_SAFE_INTEGER;

  const dotNetMatch = raw.match(/\/Date\((\d+)\)\//);
  if (dotNetMatch) return Number(dotNetMatch[1]) || Number.MIN_SAFE_INTEGER;

  const parsed = Date.parse(raw);
  if (Number.isFinite(parsed)) return parsed;

  return Number.MIN_SAFE_INTEGER;
};

const normalizeFotoSrc = (value) => {
  const raw = toText(value);
  if (!raw) return "";

  if (/^data:image\//i.test(raw)) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalizedRaw = raw.replace(/\\/g, "/");
  const compactBase64 = normalizedRaw.replace(/\s+/g, "");
  const maybeBase64 =
    compactBase64.length > 64 &&
    /^[A-Za-z0-9+/=]+$/.test(compactBase64) &&
    compactBase64.replace(/=+$/, "").length % 4 !== 1;
  if (maybeBase64) return `data:image/jpeg;base64,${compactBase64}`;

  if (normalizedRaw.startsWith("/")) {
    const withoutApiPrefix = normalizedRaw.startsWith("/api/") ? normalizedRaw.slice(4) : normalizedRaw;
    const plainPath = withoutApiPrefix.split(/[?#]/)[0];
    const isImageLikePath =
      /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(plainPath) ||
      /\/fotografias\//i.test(plainPath) ||
      /\/foto\//i.test(plainPath);
    if (!isImageLikePath) return "";
    return buildApiUrl(withoutApiPrefix);
  }

  const plainPath = normalizedRaw.split(/[?#]/)[0];
  const looksLikeRelativePath = /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(plainPath);
  if (looksLikeRelativePath) {
    const withLeadingSlash = normalizedRaw.startsWith("/") ? normalizedRaw : `/${normalizedRaw}`;
    const withoutApiPrefix = withLeadingSlash.startsWith("/api/")
      ? withLeadingSlash.slice(4)
      : withLeadingSlash;
    return buildApiUrl(withoutApiPrefix);
  }

  return "";
};

const extractFotografias = (payload = {}) => {
  const persona = payload?.persona || {};
  const sources = [
    payload?.fotografias,
    payload?.fotos,
    payload?.Fotografias,
    payload?.Fotos,
    payload?.persona_fotografias,
    payload?.personaFotografias,
    payload?.imagenes,
    payload?.imagenes_persona,
    payload?.fotografia,
    payload?.foto,
    payload?.Fotografia,
    payload?.Foto,
    persona?.fotografias,
    persona?.fotos,
    persona?.Fotografias,
    persona?.Fotos,
    persona?.fotografia,
    persona?.foto,
    persona?.Fotografia,
    persona?.Foto,
  ];

  const rows = sources.flatMap((entry) => {
    if (!entry) return [];
    if (Array.isArray(entry)) return entry;
    if (typeof entry === "object") return [entry];
    return [];
  });

  const directImage =
    payload?.Imagen ||
    payload?.imagen ||
    payload?.Image ||
    payload?.image ||
    payload?.ImagenDataUrl ||
    payload?.imagenDataUrl ||
    persona?.Imagen ||
    persona?.imagen ||
    persona?.Image ||
    persona?.image ||
    persona?.ImagenDataUrl ||
    persona?.imagenDataUrl ||
    "";
  if (directImage) {
    rows.push({
      FotoId: payload?.FotoId ?? persona?.FotoId ?? null,
      FechaCrea: payload?.FechaCrea || persona?.FechaCrea || "",
      Imagen: directImage,
    });
  }

  return rows.filter(Boolean);
};

export const getUltimaFotoPersona = (payload = {}) => {
  const fotografias = extractFotografias(payload);
  if (!fotografias.length) return "";

  const ordered = [...fotografias].sort((a, b) => {
    const timeA = toTimeValue(a?.FechaCrea || a?.fechaCrea || a?.fecha);
    const timeB = toTimeValue(b?.FechaCrea || b?.fechaCrea || b?.fecha);
    if (timeA !== timeB) return timeB - timeA;
    const idA = Number(a?.FotoId ?? a?.fotoId ?? 0) || 0;
    const idB = Number(b?.FotoId ?? b?.fotoId ?? 0) || 0;
    return idB - idA;
  });

  for (const item of ordered) {
    const src = normalizeFotoSrc(
      item?.Imagen ||
        item?.imagen ||
        item?.ImagenDataUrl ||
        item?.imagenDataUrl ||
        item?.Image ||
        item?.image ||
        item?.Url ||
        item?.url ||
        item?.Ruta ||
        item?.ruta ||
        item?.ArchivoRuta ||
        item?.archivoRuta ||
        "",
    );
    if (src) return src;
  }
  return "";
};

export const mapDesignacionSearchToUi = (data) => {
  const persona = data?.persona || {};
  const info = data?.informacion_adicional || data?.informacionAdicional || {};
  const lugarNacimiento = toText(
    info?.LugarNacimiento ||
      info?.lugarNacimiento ||
      persona?.LugarNacimiento ||
      persona?.lugarNacimiento,
  );
  const lugarNacimientoReporte = formatLugarNacimientoReporte(lugarNacimiento);
  const { grouped, withoutDesignacion } = groupBeneficiariosByDesignacion(data?.beneficiarios || []);

  const designacionesRaw = data?.designaciones || [];
  const designaciones = designacionesRaw.map((item) => {
    const designacionId = item?.idDesignacion ?? item?.DesignacionId;
    const byDesignacion = grouped.get(String(designacionId)) || [];
    const estado = normalizeDesignacionEstado(item?.estado || item?.EstadoDescripcion || item?.Estado);
    return {
      idDesignacion: designacionId,
      idAfiliado: item?.idAfiliado ?? item?.FKPersonaId ?? persona?.PersonaId,
      fechaInicio:
        item?.fechaInicio ||
        item?.FechaInicio ||
        item?.fecha_inicio ||
        item?.FechaInicioDesignacion ||
        "",
      fechaFinalizo:
        item?.fechaFinalizo ||
        item?.FechaFinalizo ||
        item?.fechaFin ||
        item?.FechaFin ||
        item?.FechaFinal ||
        item?.fecha_finalizo ||
        "",
      estado,
      designacionTipo: (item?.designacionTipo || item?.DesignacionTipo || "").toString().trim().toUpperCase(),
      numero: item?.Numero || "",
      beneficiarios: byDesignacion,
    };
  });

  if (designaciones.length === 1 && withoutDesignacion.length > 0) {
    designaciones[0].beneficiarios = withoutDesignacion;
  }

  return {
    personaId: persona?.PersonaId || "",
    personaSk: persona?.PersonaSK || "",
    dni: persona?.DocumentoNumero || persona?.PersonaId || "",
    idAfiliado: persona?.PersonaId || "",
    tipoDocumento: "IDENTIDAD",
    primerNombre: persona?.Nombre1 || "",
    segundoNombre: persona?.Nombre2 || "",
    primerApellido: persona?.Apellido1 || "",
    segundoApellido: persona?.Apellido2 || "",
    nombreCompleto: persona?.NombreCompleto || "",
    estado: persona?.Estado || "",
    sexo: persona?.SexoDescripcion || "",
    nacionalidad: persona?.NacionalidadDescripcion || "",
    fechaNacimiento: isoDate(persona?.FechaNacimiento),
    lugarNacimiento,
    lugarNacimientoReporte,
    estadoCivil: persona?.EstadoCivilDescripcion || "",
    fotoUrl: "",
    designaciones,
  };
};

export const getDesignacionTokenStatus = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  const personaId = String(options?.personaId || "").trim();
  const dni = String(options?.dni || "").trim();
  if (personaId) params.set("persona_id", personaId);
  if (!personaId && dni) params.set("dni", dni);
  const query = params.toString();
  const path = `/Enrolamiento/designaciones/verificacion-token/${query ? `?${query}` : ""}`;
  return apiRequest(path, { authToken });
};

export const crearDesignacionEnProceso = async (authToken = "", personaId = "", payload = {}) => {
  const data = await apiRequest(
    `/Enrolamiento/personas/${encodeURIComponent(personaId)}/designaciones/`,
    {
      authToken,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accion: "crear_en_proceso",
        ...payload,
      }),
    },
  );
  return data;
};

export const guardarBeneficiariosDesignacion = async (
  authToken = "",
  personaId = "",
  designacionId,
  beneficiarios = [],
) => {
  const data = await apiRequest(
    `/Enrolamiento/personas/${encodeURIComponent(personaId)}/designaciones/`,
    {
      authToken,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accion: "guardar_beneficiarios",
        designacion_id: designacionId,
        beneficiarios,
      }),
    },
  );
  return data;
};

export const confirmarDesignacionBeneficiarios = async (
  authToken = "",
  personaId = "",
  designacionId,
) => {
  const data = await apiRequest(
    `/Enrolamiento/personas/${encodeURIComponent(personaId)}/designaciones/`,
    {
      authToken,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accion: "confirmar",
        designacion_id: designacionId,
      }),
    },
  );
  return data;
};

export const adjuntarDesignacionFirmada = async (
  authToken = "",
  personaId = "",
  archivo,
  options = {},
) => {
  const observaciones = options?.observaciones || "Archivo de designación firmado";
  const formData = new FormData();
  formData.append("archivo", archivo);
  formData.append("nombre", archivo.name);
  formData.append("descripcion", observaciones);
  formData.append("observaciones", observaciones);
  formData.append("entidad", "DESIGNACION");
  if (options?.designacionId !== undefined && options?.designacionId !== null) {
    formData.append("registro", String(options.designacionId));
  }
  const data = await apiRequest(
    `/Enrolamiento/personas/${encodeURIComponent(personaId)}/adjuntos/?entidad=afiliacion`,
    {
      authToken,
      method: "POST",
      body: formData,
    },
  );
  return data;
};

export const subirFotoPersona = async (authToken = "", personaId = "", archivo, options = {}) => {
  const formData = new FormData();
  formData.append("foto", archivo);
  formData.append("observaciones", options?.observaciones || "Foto actualizada");
  const data = await apiRequest(
    `/Enrolamiento/personas/${encodeURIComponent(personaId)}/foto/`,
    { authToken, method: "POST", body: formData },
  );
  return data;
};

export const mapPersonaPayloadToForm = (payload, baseForm = {}) => {
  const persona = payload?.persona || {};
  const info = payload?.informacion_adicional || {};
  const fechaDesdeReside = isoDate(info?.TiempoResidirUbicacion);

  return {
    ...baseForm,
    personaIdInterno: toText(persona?.PersonaId),
    tipoDocumento: toText(persona?.FKDocumentoTipoId),
    identificacion: toText(persona?.DocumentoNumero || persona?.PersonaId),
    primerNombre: toText(persona?.Nombre1),
    segundoNombre: toText(persona?.Nombre2),
    primerApellido: toText(persona?.Apellido1),
    segundoApellido: toText(persona?.Apellido2),
    fechaNacimiento: isoDate(persona?.FechaNacimiento),
    paisNacimiento: toText(persona?.FKPaisNacimientoId),
    nacionalidad: toText(persona?.FKNacionalidadId),
    genero: toText(persona?.FKSexoId),
    estadoCivil: toText(persona?.FKEstadoCivilId),
    direccionCompleta: toText(persona?.Direccion),
    calle: toText(info?.Calle),
    numeroCasa: toText(info?.NumeroCasa),
    referenciaDireccion: toText(info?.ReferenciaDomicilio),
    tiempoResidir: yearsSinceDate(fechaDesdeReside),
    fechaDesdeReside,
    departamentoResidencia: toText(persona?.FKDepartamentoId),
    municipioResidencia: toText(persona?.FKMunicipioId),
    coloniaResidencia: toText(persona?.FKColoniaId),
    telefono: digitsOnly(persona?.Telefonos || persona?.Telefono || info?.Telefono),
    movil: digitsOnly(persona?.Movil),
    correo: toText(persona?.Correo),
    esPep:
      persona?.PoliticamenteExpuesta !== undefined &&
      persona?.PoliticamenteExpuesta !== null
        ? toBoolean(persona.PoliticamenteExpuesta, false)
        : false,
    rtn: toText(info?.RTN),
    lugarNacimiento: toText(info?.LugarNacimiento),
    profesion: toText(persona?.FKProfesionOficioId || info?.FKProfesionOficioId),
    actividadEconomicaCnbs: toText(persona?.FKActividadEconomicaCnbsID),
    profesionCnbs: toText(persona?.FKProfesionCnbsID),
    nivelEducativo: toText(persona?.FKNivelEducativoId || info?.FKNivelEducativoId),
    tipoCliente: toText(info?.FKTipoClienteSolicitanteId),
    dependientesEconomicos:
      info?.DependientesEconomicos !== undefined && info?.DependientesEconomicos !== null
        ? String(info.DependientesEconomicos)
        : "",
    patrono: toText(info?.EmpleadoPatrono),
    departamentoTrabajo: toText(persona?.FKDepartamentoTrabajoId || info?.FKDepartamentoTrabajoId || persona?.FKDepartamentoId),
    municipioTrabajo: toText(persona?.FKMunicipioTrabajoId || info?.FKMunicipioTrabajoId || persona?.FKMunicipioId),
    coloniaTrabajo: toText(persona?.FKColoniaTrabajoId || info?.FKColoniaTrabajoId || persona?.FKColoniaId),
    direccionTrabajo: toText(persona?.DireccionTrabajo || info?.DireccionTrabajo),
    numeroCasaTrabajo: toText(info?.NumeroCasaTrabajo),
    referenciaTrabajo: toText(info?.RefrerenciaUbicacionTrabajo),
    fechaIngresoInstitucion: isoDate(info?.FechaIngresoInstitucion),
    antiguedadLaboral: toText(info?.AntiguedadLaboral),
    ingresoAproxRango: toText(info?.FKIngresosAproximadosId),
    ingresoAproxMonto:
      info?.IngresosMensuales !== undefined && info?.IngresosMensuales !== null
        ? String(info.IngresosMensuales)
        : "",
    giroEntidad: toText(info?.FKGiroEntidadId),
    cargoDesempenado: toText(info?.FKCargoId),
    areaTrabajo: toText(persona?.AreaTrabajo || info?.AreaTrabajo),
    telefonoTrabajo: digitsOnly(persona?.TelefonoTrabajo || info?.TelefonoTrabajo),
    tipoVivienda: toText(info?.FKViviendaTipoId),
    numeroVehiculos:
      info?.NumeroVehiculo !== undefined && info?.NumeroVehiculo !== null
        ? String(info.NumeroVehiculo)
        : "",
    descOtrosInmuebles:
      toText(info?.DescripcionOtrosInmuebles),
    descOtrosIngresos:
      toText(info?.DescripcionOtrosIngresos),
    montoOtrosIngresos:
      info?.MontoOtrosIngresos !== undefined && info?.MontoOtrosIngresos !== null
        ? String(info.MontoOtrosIngresos)
        : "",
    poseeVehiculo:
      info?.PoseeVihiculo !== undefined && info?.PoseeVihiculo !== null
        ? toBoolean(info.PoseeVihiculo, false)
        : false,
    poseeInmuebles:
      info?.OtrosInmuebles !== undefined && info?.OtrosInmuebles !== null
        ? toBoolean(info.OtrosInmuebles, false)
        : false,
    otrosIngresos:
      info?.OtrosIngresos !== undefined && info?.OtrosIngresos !== null
        ? toBoolean(info.OtrosIngresos, false)
        : false,
    propiedadesPersonales:
      info?.PropiedadesPersonales !== undefined &&
      info?.PropiedadesPersonales !== null
        ? toBoolean(info.PropiedadesPersonales, false)
        : false,
    ingresosPersonales:
      info?.IngresosPersonales !== undefined && info?.IngresosPersonales !== null
        ? toBoolean(info.IngresosPersonales, false)
        : false,
    perfilLaft: toText(info?.FKPerfilLAFTId),
    nombreConyuge: toText(info?.ConyugeNombre),
    identificacionConyuge:
      toText(info?.ConyugeDocumentoNumero),
    fechaNacimientoConyuge:
      isoDate(info?.ConyugeFechaNacimiento),
    tipoDocumentoConyuge:
      info?.FKConyugeDocumentoTipoId !== undefined &&
      info?.FKConyugeDocumentoTipoId !== null
        ? String(info.FKConyugeDocumentoTipoId)
        : "",
    generoConyuge: toText(info?.FKConyugeSexoId),
    estadoHuellas: toText(persona?.EstadoHuellas),
    registroAfis: toText(persona?.RegistroAfis),
    transaccionOrigen: toText(persona?.TransaccionOrigen),
    observacionesPersona: toText(persona?.Observaciones),
    observacionHuellas: toText(persona?.ObservacionHuellas),
    userIdRegistro: toText(persona?.UserIdRegistro),
    userRegistroNombre: toText(persona?.UserRegistroNombre),
    oficinaIdRegistro: toText(persona?.OficinaIdRegistro),
    oficinaIdRegistroNombre: toText(persona?.OficinaIdRegistroNombre),
    userIdActualizo: toText(persona?.UserIdActualizo),
    userActualizoNombre: toText(persona?.UserActualizoNombre),
  };
};

export const buildActualizarPayload = ({
  form,
  referencias,
  beneficiarios,
  padecimientos,
  cargosPublicos,
  empresasPpe,
  familiaresPpe,
}) => {
  const persona = {
    persona_id: form.personaIdInterno || form.identificacion,
    documento_numero: form.identificacion,
    primerNombre: form.primerNombre,
    segundoNombre: form.segundoNombre,
    primerApellido: form.primerApellido,
    segundoApellido: form.segundoApellido,
    tipoDocumento: form.tipoDocumento,
    fechaNacimiento: form.fechaNacimiento,
    paisNacimiento: form.paisNacimiento,
    genero: form.genero,
    estadoCivil: form.estadoCivil,
    nacionalidad: form.nacionalidad,
    direccionCompleta: form.direccionCompleta,
    telefono: digitsOnly(form.telefono),
    telefonos: digitsOnly(form.telefono),
    movil: digitsOnly(form.movil),
    correo: form.correo,
    esPep: Boolean(form.esPep),
    rtn: form.rtn,
    calle: form.calle,
    numeroCasa: form.numeroCasa,
    referenciaDireccion: form.referenciaDireccion,
    tiempoResidir: form.tiempoResidir,
    fechaDesdeReside: form.fechaDesdeReside,
    patrono: form.patrono,
    departamentoTrabajo: form.departamentoTrabajo,
    municipioTrabajo: form.municipioTrabajo,
    coloniaTrabajo: form.coloniaTrabajo,
    direccionTrabajo: form.direccionTrabajo,
    areaTrabajo: form.areaTrabajo,
    telefonoTrabajo: digitsOnly(form.telefonoTrabajo),
    numeroCasaTrabajo: form.numeroCasaTrabajo,
    referenciaTrabajo: form.referenciaTrabajo,
    fechaIngresoInstitucion: form.fechaIngresoInstitucion,
    antiguedadLaboral: form.antiguedadLaboral,
    ingresoAproxMonto: form.ingresoAproxMonto,
    dependientesEconomicos: form.dependientesEconomicos,
    numeroVehiculos: form.numeroVehiculos,
    descOtrosInmuebles: form.descOtrosInmuebles,
    descOtrosIngresos: form.descOtrosIngresos,
    montoOtrosIngresos: form.montoOtrosIngresos,
    lugarNacimiento: form.lugarNacimiento,
    profesion: form.profesion,
    actividadEconomicaCnbs: form.actividadEconomicaCnbs,
    profesionCnbs: form.profesionCnbs,
    nivelEducativo: form.nivelEducativo,
    poseeVehiculo: form.poseeVehiculo,
    poseeInmuebles: form.poseeInmuebles,
    otrosIngresos: form.otrosIngresos,
    propiedadesPersonales: form.propiedadesPersonales,
    ingresosPersonales: form.ingresosPersonales,
    nombreConyuge: form.nombreConyuge,
    identificacionConyuge: form.identificacionConyuge,
    fechaNacimientoConyuge: form.fechaNacimientoConyuge,
    tipoDocumentoConyuge: form.tipoDocumentoConyuge,
    generoConyuge: form.generoConyuge,
    tipoVivienda: form.tipoVivienda,
    cargoDesempenado: form.cargoDesempenado,
    ingresoAproxRango: form.ingresoAproxRango,
    perfilLaft: form.perfilLaft,
    tipoCliente: form.tipoCliente,
    giroEntidad: form.giroEntidad,
    departamentoResidencia: form.departamentoResidencia,
    municipioResidencia: form.municipioResidencia,
    coloniaResidencia: form.coloniaResidencia,
    estadoHuellas: form.estadoHuellas,
    registroAfis: form.registroAfis,
    transaccionOrigen: form.transaccionOrigen,
    observacionesPersona: form.observacionesPersona,
    observacionHuellas: form.observacionHuellas,
  };

  return {
    persona,
    referencias: (referencias || []).map((row) => ({
      referenciaId: row?.referenciaId || row?.ReferenciaId || null,
      nombreCompleto: row?.nombreCompleto || row?.nombre || row?.Nombre || row?.[0] || "",
      telefono: digitsOnly(row?.telefono || row?.Telefono || row?.[1] || ""),
      direccion: row?.direccion || row?.Direccion || "",
      tipoReferencia:
        row?.tipoReferencia || row?.TipoReferencia || row?.FKReferenciaTipoId || row?.tipo || row?.[2] || "",
      FKReferenciaTipoId:
        row?.FKReferenciaTipoId || row?.tipoReferenciaId || row?.tipoReferencia || row?.TipoReferencia || "",
    })),
    beneficiarios: (beneficiarios || []).map((row) => ({
      beneficiarioId: row?.beneficiarioId || row?.BeneficiarioId || null,
      dni:
        row?.dni ||
        row?.DocumentoNumero ||
        row?.documentoNumero ||
        row?.numeroDocumento ||
        row?.[0] ||
        "",
      primerNombre: row?.primerNombre || row?.Nombre1 || row?.nombre1 || row?.[1] || "",
      segundoNombre: row?.segundoNombre || row?.Nombre2 || row?.nombre2 || row?.[2] || "",
      primerApellido: row?.primerApellido || row?.Apellido1 || row?.apellido1 || row?.[3] || "",
      segundoApellido: row?.segundoApellido || row?.Apellido2 || row?.apellido2 || row?.[4] || "",
      parentesco: row?.parentesco || row?.FKParentescoId || "",
      tipoDocumento: row?.tipoDocumento || row?.FKDocumentoTipoId || form.tipoDocumento || "",
      porcentaje: row?.porcentaje ?? row?.Porcentaje ?? 0,
      tipo: row?.tipo || row?.Tipo || "Potencial",
      esLegal: row?.esLegal ?? row?.EsLegal ?? false,
      FKDesignacionId: row?.FKDesignacionId || null,
    })),
    padecimientos: (padecimientos || []).map((row) => ({
      id: row?.id || row?.FKPadecimientoMedicoId || row?.padecimiento_id || "",
      descripcion: row?.descripcion || row?.Descripcion || row?.nombre || "",
    })),
    cargos_publicos: cargosPublicos || [],
    empresas_ppe: (empresasPpe || []).map((row) => ({
      relacionEmpresaId: row?.relacionEmpresaId || row?.RelacionEmpresaId || row?.id || null,
      razonSocial: row?.razonSocial || row?.RazonSocial || "",
      rtn: row?.rtn || row?.RTN || "",
      giroEntidad:
        row?.giroEntidad ||
        row?.FKGiroEntidadId ||
        row?.giroNegocio ||
        row?.GiroNegocio ||
        "",
      pais: row?.pais || row?.FKNacionalidadId || row?.nacionalidad || "",
      FKGiroEntidadId:
        row?.FKGiroEntidadId ||
        row?.giroEntidad ||
        row?.giroNegocio ||
        row?.GiroNegocio ||
        "",
      FKNacionalidadId: row?.FKNacionalidadId || row?.pais || row?.nacionalidad || "",
    })),
    familiares_ppe: (familiaresPpe || []).map((row) => ({
      personaPolicamenteExpuestaFamiliaresId:
        row?.personaPolicamenteExpuestaFamiliaresId ||
        row?.PersonaPolicamenteExpuestaFamiliaresId ||
        row?.id ||
        null,
      primerNombre: row?.primerNombre || row?.Nombre1 || "",
      segundoNombre: row?.segundoNombre || row?.Nombre2 || "",
      primerApellido: row?.primerApellido || row?.Apellido1 || "",
      segundoApellido: row?.segundoApellido || row?.Apellido2 || "",
      parentesco: row?.parentesco || row?.FKParentescoId || "",
      nacionalidad: row?.nacionalidad || row?.FKNacionalidadId || "",
      PersonaPolicamenteExpuestaFamiliaresId:
        row?.PersonaPolicamenteExpuestaFamiliaresId ||
        row?.personaPolicamenteExpuestaFamiliaresId ||
        row?.id ||
        null,
      Nombre1: row?.Nombre1 || row?.primerNombre || "",
      Nombre2: row?.Nombre2 || row?.segundoNombre || "",
      Apellido1: row?.Apellido1 || row?.primerApellido || "",
      Apellido2: row?.Apellido2 || row?.segundoApellido || "",
      FKParentescoId: row?.FKParentescoId || row?.parentesco || "",
      FKNacionalidadId: row?.FKNacionalidadId || row?.nacionalidad || "",
    })),
    beneficiario_tipo: "P",
  };
};

const _boolToQueryValue = (value) => (value ? "1" : "0");
const _DEFAULT_PAGINATION = {
  page: 1,
  page_size: 25,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
};

const _withPaginationParams = (params, options = {}, defaultPage = 1, defaultPageSize = 25) => {
  const page = Number(options?.page || defaultPage);
  const pageSize = Number(options?.pageSize || options?.page_size || defaultPageSize);
  params.set("page", String(Number.isFinite(page) && page > 0 ? page : defaultPage));
  params.set(
    "page_size",
    String(Number.isFinite(pageSize) && pageSize > 0 ? pageSize : defaultPageSize),
  );
};

const _normalizePagination = (raw = {}, fallbackPage = 1, fallbackPageSize = 25) => ({
  page: Number(raw?.page || fallbackPage) || fallbackPage,
  page_size: Number(raw?.page_size || fallbackPageSize) || fallbackPageSize,
  total: Number(raw?.total || 0) || 0,
  total_pages: Number(raw?.total_pages || 0) || 0,
  has_next: Boolean(raw?.has_next),
  has_prev: Boolean(raw?.has_prev),
});

export const listarEstadoCivilMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.incluirInactivos !== undefined) {
    params.set("incluir_inactivos", _boolToQueryValue(Boolean(options.incluirInactivos)));
  }
  _withPaginationParams(params, options, 1, 25);
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/estado-civil/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 25)),
  };
};

export const crearEstadoCivilMantenimiento = async (authToken = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest("/Enrolamiento/mantenimientos/estado-civil/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarEstadoCivilMantenimiento = async (
  authToken = "",
  estadoCivilId = "",
  payload = {},
) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest(
    `/Enrolamiento/mantenimientos/estado-civil/${encodeURIComponent(estadoCivilId)}/`,
    {
      authToken,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payloadWithUser),
    },
  );
  return data?.item || null;
};

export const eliminarEstadoCivilMantenimiento = async (authToken = "", estadoCivilId = "") => {
  await apiRequest(`/Enrolamiento/mantenimientos/estado-civil/${encodeURIComponent(estadoCivilId)}/`, {
    authToken,
    method: "DELETE",
  });
  return true;
};

export const listarSexoMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.incluirInactivos !== undefined) {
    params.set("incluir_inactivos", _boolToQueryValue(Boolean(options.incluirInactivos)));
  }
  _withPaginationParams(params, options, 1, 25);
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/sexos/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 25)),
  };
};

export const crearSexoMantenimiento = async (authToken = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest("/Enrolamiento/mantenimientos/sexos/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarSexoMantenimiento = async (authToken = "", sexoId = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest(`/Enrolamiento/mantenimientos/sexos/${encodeURIComponent(sexoId)}/`, {
    authToken,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const eliminarSexoMantenimiento = async (authToken = "", sexoId = "") => {
  await apiRequest(`/Enrolamiento/mantenimientos/sexos/${encodeURIComponent(sexoId)}/`, {
    authToken,
    method: "DELETE",
  });
  return true;
};

export const listarCargosMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.incluirInactivos !== undefined) {
    params.set("incluir_inactivos", _boolToQueryValue(Boolean(options.incluirInactivos)));
  }
  if (options?.id) params.set("cargo_id", String(options.id).trim());
  if (options?.descripcion) params.set("descripcion", String(options.descripcion).trim());
  if (options?.estado && String(options.estado).toUpperCase() !== "TODOS") {
    params.set("estado", String(options.estado).trim());
  }
  if (options?.cargoPublico && String(options.cargoPublico).toUpperCase() !== "TODOS") {
    params.set("cargo_publico", String(options.cargoPublico).trim());
  }
  _withPaginationParams(params, options, 1, 25);
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/cargos/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 25)),
  };
};

export const crearCargoMantenimiento = async (authToken = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest("/Enrolamiento/mantenimientos/cargos/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarCargoMantenimiento = async (authToken = "", cargoId, payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest(`/Enrolamiento/mantenimientos/cargos/${encodeURIComponent(cargoId)}/`, {
    authToken,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const eliminarCargoMantenimiento = async (authToken = "", cargoId) => {
  await apiRequest(`/Enrolamiento/mantenimientos/cargos/${encodeURIComponent(cargoId)}/`, {
    authToken,
    method: "DELETE",
  });
  return true;
};

export const listarProfesionesOficiosMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.incluirInactivos !== undefined) {
    params.set("incluir_inactivos", _boolToQueryValue(Boolean(options.incluirInactivos)));
  }
  if (options?.id) params.set("profesion_oficio_id", String(options.id).trim());
  if (options?.descripcion) params.set("descripcion", String(options.descripcion).trim());
  if (options?.estado && String(options.estado).toUpperCase() !== "TODOS") {
    params.set("estado", String(options.estado).trim());
  }
  _withPaginationParams(params, options, 1, 25);
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/profesiones-oficios/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 25)),
  };
};

export const crearProfesionOficioMantenimiento = async (authToken = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest("/Enrolamiento/mantenimientos/profesiones-oficios/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarProfesionOficioMantenimiento = async (authToken = "", profesionOficioId, payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest(
    `/Enrolamiento/mantenimientos/profesiones-oficios/${encodeURIComponent(profesionOficioId)}/`,
    {
      authToken,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payloadWithUser),
    },
  );
  return data?.item || null;
};

export const eliminarProfesionOficioMantenimiento = async (authToken = "", profesionOficioId) => {
  await apiRequest(
    `/Enrolamiento/mantenimientos/profesiones-oficios/${encodeURIComponent(profesionOficioId)}/`,
    {
      authToken,
      method: "DELETE",
    },
  );
  return true;
};

export const listarColoniasMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.municipioId) params.set("municipio_id", String(options.municipioId).trim());
  if (options?.departamentoId) params.set("departamento_id", String(options.departamentoId).trim());
  if (options?.id) params.set("colonia_id", String(options.id).trim());
  if (options?.nombre) params.set("nombre", String(options.nombre).trim());
  if (options?.includeCatalogos) params.set("include_catalogos", "1");
  _withPaginationParams(params, options, 1, 25);
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/colonias/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 25)),
    catalogos: data?.catalogos || {},
  };
};

export const obtenerColoniaMantenimiento = async (authToken = "", coloniaId = "") => {
  const id = String(coloniaId || "").trim();
  if (!id) return null;
  try {
    const data = await apiRequest(`/Enrolamiento/mantenimientos/colonias/${encodeURIComponent(id)}/`, {
      authToken,
      method: "GET",
    });
    return data?.item || null;
  } catch (err) {
    const status = Number(err?.status || 0);
    if (status === 404 || /HTTP 404/i.test(String(err?.message || ""))) {
      return null;
    }
    throw err;
  }
};

export const crearColoniaMantenimiento = async (authToken = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest("/Enrolamiento/mantenimientos/colonias/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarColoniaMantenimiento = async (authToken = "", coloniaId = "", payload = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const data = await apiRequest(`/Enrolamiento/mantenimientos/colonias/${encodeURIComponent(coloniaId)}/`, {
    authToken,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const eliminarColoniaMantenimiento = async (authToken = "", coloniaId = "") => {
  await apiRequest(`/Enrolamiento/mantenimientos/colonias/${encodeURIComponent(coloniaId)}/`, {
    authToken,
    method: "DELETE",
  });
  return true;
};

export const listarFirmasMantenimiento = async (authToken = "", options = {}) => {
  const params = new URLSearchParams();
  if (options?.incluirInactivos !== undefined) {
    params.set("incluir_inactivos", _boolToQueryValue(Boolean(options.incluirInactivos)));
  }
  if (options?.incluirImagen !== undefined) {
    params.set("incluir_imagen", _boolToQueryValue(Boolean(options.incluirImagen)));
  }
  if (options?.firmaId !== undefined && options?.firmaId !== null && options?.firmaId !== "") {
    params.set("firma_id", String(options.firmaId).trim());
  }
  if (!params.has("firma_id")) {
    _withPaginationParams(params, options, 1, 15);
  }
  const query = params.toString();
  const path = `/Enrolamiento/mantenimientos/firmas/${query ? `?${query}` : ""}`;
  const data = await apiRequest(path, { authToken, method: "GET" });
  if (data?.item) return data.item;
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    pagination: _normalizePagination(data?.pagination, Number(options?.page || 1), Number(options?.pageSize || 15)),
  };
};

export const crearFirmaMantenimiento = async (authToken = "", payload = {}, options = {}) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const hasFile = options?.imagenFile instanceof File;
  if (hasFile) {
    const formData = new FormData();
    Object.entries(payloadWithUser || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      formData.append(key, value);
    });
    formData.append("imagen", options.imagenFile);
    const data = await apiRequest("/Enrolamiento/mantenimientos/firmas/", {
      authToken,
      method: "POST",
      body: formData,
    });
    return data?.item || null;
  }

  const data = await apiRequest("/Enrolamiento/mantenimientos/firmas/", {
    authToken,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const actualizarFirmaMantenimiento = async (
  authToken = "",
  firmaId,
  payload = {},
  options = {},
) => {
  const payloadWithUser = withUserIdRegistro(payload);
  const hasFile = options?.imagenFile instanceof File;
  if (hasFile) {
    const formData = new FormData();
    Object.entries(payloadWithUser || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      formData.append(key, value);
    });
    formData.append("imagen", options.imagenFile);
    const data = await apiRequest(
      `/Enrolamiento/mantenimientos/firmas/${encodeURIComponent(firmaId)}/`,
      {
        authToken,
        method: "PUT",
        body: formData,
      },
    );
    return data?.item || null;
  }

  const data = await apiRequest(`/Enrolamiento/mantenimientos/firmas/${encodeURIComponent(firmaId)}/`, {
    authToken,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payloadWithUser),
  });
  return data?.item || null;
};

export const eliminarFirmaMantenimiento = async (authToken = "", firmaId) => {
  await apiRequest(`/Enrolamiento/mantenimientos/firmas/${encodeURIComponent(firmaId)}/`, {
    authToken,
    method: "DELETE",
  });
  return true;
};

const _toMonthRangeDate = (monthValue, endOfMonth = false) => {
  const raw = String(monthValue || "").trim();
  if (!/^\d{4}-\d{2}$/.test(raw)) return "";
  const [yearText, monthText] = raw.split("-");
  const year = Number(yearText);
  const month = Number(monthText);
  if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) return "";
  if (!endOfMonth) return `${yearText}-${monthText}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  return `${yearText}-${monthText}-${String(lastDay).padStart(2, "0")}`;
};

const _buildReporteriaQuery = (filters = {}) => {
  const params = new URLSearchParams();
  const fechaInicioDirecta = String(
    filters?.fechaInicio || filters?.fecha_inicio || filters?.dateFrom || "",
  ).trim();
  const fechaFinDirecta = String(
    filters?.fechaFin || filters?.fecha_fin || filters?.dateTo || "",
  ).trim();
  const fechaInicio =
    fechaInicioDirecta ||
    _toMonthRangeDate(filters?.mesInicio || filters?.monthFrom, false);
  const fechaFin =
    fechaFinDirecta ||
    _toMonthRangeDate(
      filters?.mesFin || filters?.monthTo || filters?.mesInicio,
      true,
    );
  if (fechaInicio) params.set("fecha_inicio", fechaInicio);
  if (fechaFin) params.set("fecha_fin", fechaFin);

  const oficinaTipo = String(filters?.oficinaTipo || filters?.officeType || "").trim();
  if (oficinaTipo) params.set("oficina_tipo", oficinaTipo);

  const oficinaId = String(filters?.oficinaId || filters?.officeId || "").trim();
  if (oficinaId) params.set("oficina_id", oficinaId);

  const usuarioId = String(filters?.usuarioId || filters?.userId || "").trim();
  if (usuarioId) params.set("usuario_id", usuarioId);

  const query = params.toString();
  return query ? `?${query}` : "";
};

export const obtenerCatalogosReporteriaEnrolamiento = async (authToken = "") => {
  const data = await apiRequest("/Enrolamiento/reporteria/catalogos/", {
    authToken,
    method: "GET",
  });
  return data?.catalogos || { oficinas: [], usuarios: [] };
};

export const obtenerDashboardEnrolamiento = async (authToken = "", filters = {}) => {
  const data = await apiRequest(`/Enrolamiento/reporteria/dashboard/${_buildReporteriaQuery(filters)}`, {
    authToken,
    method: "GET",
  });
  return data || {};
};

export const obtenerReporteProduccionEnrolamiento = async (authToken = "", filters = {}) => {
  const data = await apiRequest(`/Enrolamiento/reporteria/produccion/${_buildReporteriaQuery(filters)}`, {
    authToken,
    method: "GET",
  });
  return data || {};
};

export const obtenerReporteProduccionResumenEnrolamiento = async (authToken = "", filters = {}) => {
  const data = await apiRequest(`/Enrolamiento/reporteria/produccion/resumen/${_buildReporteriaQuery(filters)}`, {
    authToken,
    method: "GET",
  });
  return data || {};
};

export const obtenerReporteProduccionUsuariosEnrolamiento = async (authToken = "", filters = {}) => {
  const data = await apiRequest(`/Enrolamiento/reporteria/usuarios/${_buildReporteriaQuery(filters)}`, {
    authToken,
    method: "GET",
  });
  return data || {};
};

export const obtenerReporteUsuariosDetalleEnrolamiento = async (authToken = "", filters = {}) => {
  const data = await apiRequest(
    `/Enrolamiento/reporteria/usuarios/detalle/${_buildReporteriaQuery(filters)}`,
    {
      authToken,
      method: "GET",
    },
  );
  return data || {};
};

export const toIsoDate = fromDdMmYyyyToIso;

/**
 * Consulta el proxy backend del RNP para obtener los nombres de una persona
 * dado su número de identidad/DNI.
 *
 * Retorna { success, encontrado, nombres: { primer_nombre, segundo_nombre,
 *   primer_apellido, segundo_apellido } } o lanza un error.
 */
export const consultarRnpIdentidad = async (authToken = "", dni = "") => {
  const data = await apiRequest(
    `/Enrolamiento/rnp/identidad/?dni=${encodeURIComponent(dni)}`,
    { authToken, method: "GET" },
  );
  return data;
};
